module.exports = __webpack_public_path__ + "static/media/bridgeOfSighs.bcf46bfb.jpg";